import { useRef, useCallback } from 'react';

// Button/anchor that subtly pulls toward the cursor. Renders as <a> if href given.
export function MagneticButton({ as, href, children, className = '', strength = 0.35, ...rest }) {
  const ref = useRef(null);

  const enabled = () =>
    typeof window !== 'undefined' &&
    window.matchMedia('(hover: hover)').matches &&
    !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const onMove = useCallback(
    (e) => {
      const el = ref.current;
      if (!el || !enabled()) return;
      const rect = el.getBoundingClientRect();
      const x = (e.clientX - rect.left - rect.width / 2) * strength;
      const y = (e.clientY - rect.top - rect.height / 2) * strength;
      el.style.transform = `translate(${x}px, ${y}px)`;
    },
    [strength]
  );

  const onLeave = useCallback(() => {
    const el = ref.current;
    if (el) el.style.transform = '';
  }, []);

  const Tag = as || (href ? 'a' : 'button');
  return (
    <Tag
      ref={ref}
      href={href}
      className={`magnetic ${className}`}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      {...rest}
    >
      {children}
    </Tag>
  );
}
